import { createFileRoute } from '@tanstack/react-router';

import { MyPosts } from '#modules/finder/features/posts/components/MyPosts';

export const Route = createFileRoute(
  '/{-$locale}/_layout/_dashboard/_authed/dashboard/discover/posts/_posts/profile'
)({
  component: MyPosts,
  ssr: false,
});
